import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { Col, Form, Button } from 'react-bootstrap';
import { formatDate } from 'utils/functions';
import IconButton from 'components/common/IconButton';
import ExportReportButton from 'components/ExportReportButton';

const OutboxTableHeader = ({ modes = ['EMAIL', 'FAX', 'SMS'], searchParams = {}, handleBulkActions, selectedRowIds, page, refreshLastQuery = () => { } } = {}) => {
	const formRef = useRef();
	const onClick = async (e) => {
		if (e) {
			e.preventDefault();
			e.stopPropagation();
		}

		let bulk_action = e.target?.innerText ? `${e.target.innerText}`.toLowerCase() : '';
		const formData = new FormData(formRef.current);
		let formDataObj = { bulk_action };
		for (let [key, value] of formData) {
			formDataObj[key] = value;
		}
		if (typeof handleBulkActions === 'function' && bulk_action) {
			let selectedRows = Array.isArray(page) ? page.reduce((acc, { isSelected = false, original } = {}) => (
				[...acc, ...(isSelected ? [original] : [])]
			), []) : [];
			let selectedIds = selectedRows.length > 0 ? selectedRows.map(({ id } = {}) => id) : [];
			await handleBulkActions(formDataObj, selectedRows, selectedIds);
		}
	};

	const onSubmit = async (e) => {
		if (e) {
			e.preventDefault();
			e.stopPropagation();
		}

		const formData = new FormData(formRef.current);
		let formDataObj = {};
		for (let [key, value] of formData) {
			formDataObj[key] = value;
		}
		if (typeof handleBulkActions === 'function' && formDataObj.bulk_action) {
			let selectedRows = Array.isArray(page) ? page.reduce((acc, { isSelected = false, original } = {}) => (
				[...acc, ...(isSelected ? [original] : [])]
			), []) : [];
			let selectedIds = selectedRows.length > 0 ? selectedRows.map(({ id } = {}) => id) : [];
			await handleBulkActions(formDataObj, selectedRows, selectedIds);
		}
	};

	const selectedIds = Array.isArray(page)
		? (page.reduce((acc, { isSelected = false, original } = {}) => (
			[...acc, ...(isSelected ? [original] : [])]
		), [])).map(({ id } = {}) => id)
		: [];

	return (
		<Form noValidate ref={formRef} onSubmit={onSubmit} className="row flex-between-center">
			<Col xs={4} sm="auto" className="d-flex align-items-center pe-0">
				<h5 className="fs-0 mb-0 text-nowrap py-2 py-xl-0">Outbox</h5>
			</Col>
			<Col xs={8} sm="auto" className="ms-auto text-end ps-0">
				{Object.keys(selectedRowIds).length > 0 ? (
					<div className="d-flex">
						<Form.Select size="sm" aria-label="Bulk actions" name="bulk_action" className="flex-grow-1 w-auto">
							<option value="delete">Delete</option>
						</Form.Select>
						<Button
							type="submit"
							variant="falcon-default"
							size="sm"
							className="ms-2"
						>
							Apply
						</Button>
						<ExportReportButton
							controllerName="InboxOutbox"
							fnName="searchAllInboxOutboxFn"
							saveAs={`Outbox_${formatDate(new Date(), "YYYY-MM-DD")}.xlsx`}
							params={{
								...searchParams,
								offset: 0,
								limit: null,
								selectedRowIds: selectedIds,
							}}
							flattenData // whenever the return data rows has dataValues or any objects inside it, set this to true to flatten the data in the rows exported to excel
							appendDuplicates={false} // if true, flattened data with duplicates will be appended to each other 
							overwriteDuplicates={false} // if true, flattened data with duplicates will be overwritten with the last value. false will keep the first value and any more duplicates will be ignored 
						/>
					</div>
				) : (
					<div id="orders-actions">
						<Button variant="falcon-default" size="sm" className="ms-2" type="button" onClick={refreshLastQuery}>Refresh</Button>
						{modes.includes('MAIL') ? <Button variant="falcon-default" size="sm" className="ms-2" type="button" onClick={onClick}>View Outbox</Button>
							: <Button variant="falcon-default" size="sm" className="ms-2" type="button" onClick={onClick}>View Regular Mail</Button>}
						<IconButton
							variant="falcon-default"
							size="sm"
							icon="filter"
							transform="shrink-3"
							className="mx-2"
							type="button"
							onClick={onClick}
						>
							<span className="d-none d-sm-inline-block ms-1">Filter</span>
						</IconButton>
						<ExportReportButton
							controllerName="InboxOutbox"
							fnName="searchAllInboxOutboxFn"
							saveAs={`Outbox_${formatDate(new Date(), "YYYY-MM-DD")}.xlsx`}
							params={{
								...searchParams,
								offset: 0,
								limit: null,
								selectedRowIds: selectedIds,
							}}
							flattenData // whenever the return data rows has dataValues or any objects inside it, set this to true to flatten the data in the rows exported to excel
							appendDuplicates={false} // if true, flattened data with duplicates will be appended to each other 
							overwriteDuplicates={false} // if true, flattened data with duplicates will be overwritten with the last value. false will keep the first value and any more duplicates will be ignored 
						/>
					</div>
				)}
			</Col>
		</Form>
	);
};

OutboxTableHeader.propTypes = {
	page: PropTypes.array,
	selectedRowIds: PropTypes.object,
	modes: PropTypes.array,
	searchParams: PropTypes.object,
	handleBulkActions: PropTypes.func,
	refreshLastQuery: PropTypes.func,
};

export default OutboxTableHeader;